"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    skeletonVariants: ()=>skeletonVariants,
    skeletonTypographyTypes: ()=>skeletonTypographyTypes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const skeletonSlots = {
    skeletonWrapperSlot: 'content-center',
    skeletonSlot: 'flex w-50 h-8 relative',
    skeletonImageSlot: 'absolute inset-0 rounded-[inherit]'
};
const skeletonTypographyTypes = {
    h1: {
        skeletonWrapperSlot: 'h-12',
        skeletonSlot: 'h-10 rounded-sm'
    },
    h2: {
        skeletonWrapperSlot: 'h-10',
        skeletonSlot: 'h-8 rounded-sm'
    },
    h3: {
        skeletonWrapperSlot: 'h-8',
        skeletonSlot: 'h-6.5 rounded-sm'
    },
    h4: {
        skeletonWrapperSlot: 'h-6',
        skeletonSlot: 'h-5 rounded-sm'
    },
    h5: {
        skeletonWrapperSlot: 'h-5',
        skeletonSlot: 'h-4 rounded-sm'
    },
    h6: {
        skeletonWrapperSlot: 'h-4',
        skeletonSlot: 'h-3.5 rounded-sm'
    },
    body1: {
        skeletonWrapperSlot: 'h-6',
        skeletonSlot: 'h-4 rounded-sm'
    },
    body2: {
        skeletonWrapperSlot: 'h-5',
        skeletonSlot: 'h-3.5 rounded-sm'
    },
    body3: {
        skeletonWrapperSlot: 'h-4',
        skeletonSlot: 'h-3 rounded-sm'
    },
    article: {
        skeletonWrapperSlot: 'h-7',
        skeletonSlot: 'h-4 rounded-sm'
    },
    disclaimer: {
        skeletonWrapperSlot: 'h-4',
        skeletonSlot: 'h-2.75 rounded-sm'
    },
    label: {
        skeletonWrapperSlot: 'h-3.5',
        skeletonSlot: 'h-2.5 rounded-sm'
    }
};
const skeletonTypeVariants = {
    ...skeletonTypographyTypes,
    btn_sm: {
        skeletonSlot: 'w-18 h-8 rounded-full'
    },
    btn_md: {
        skeletonSlot: 'w-22 h-10 rounded-full'
    },
    btn_lg: {
        skeletonSlot: 'w-24 h-12 rounded-lg'
    },
    btn_xl: {
        skeletonSlot: 'w-24 h-14 rounded-lg'
    },
    image: {
        skeletonSlot: 'inline-flex justify-center items-center'
    }
};
const skeletonEmphasisVariants = {
    regular: {
        skeletonSlot: 'bg-neutral-2'
    },
    medium: {
        skeletonSlot: 'bg-neutral-5'
    },
    bold: {
        skeletonSlot: 'bg-neutral-1/40'
    }
};
const skeletonEmphasisCompoundVariants = [
    {
        type: 'image',
        emphasis: 'regular',
        class: {
            skeletonSlot: 'bg-transparent',
            skeletonImageSlot: 'bg-neutral-2'
        }
    },
    {
        type: 'image',
        emphasis: 'medium',
        class: {
            skeletonSlot: 'bg-transparent',
            skeletonImageSlot: 'bg-neutral-5'
        }
    },
    {
        type: 'image',
        emphasis: 'bold',
        class: {
            skeletonSlot: 'bg-transparent',
            skeletonImageSlot: 'bg-neutral-1/40'
        }
    }
];
const skeletonAnimationVariants = {
    true: {
        skeletonSlot: 'animate-skeleton-pulse'
    },
    false: {
        skeletonSlot: ''
    }
};
const skeletonDefaultVariants = {
    emphasis: 'regular'
};
const skeletonVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: skeletonSlots,
    variants: {
        type: skeletonTypeVariants,
        emphasis: skeletonEmphasisVariants,
        animate: skeletonAnimationVariants
    },
    compoundVariants: skeletonEmphasisCompoundVariants,
    defaultVariants: skeletonDefaultVariants
});
exports.skeletonTypographyTypes = __webpack_exports__.skeletonTypographyTypes;
exports.skeletonVariants = __webpack_exports__.skeletonVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "skeletonTypographyTypes",
    "skeletonVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
